import React from "react";

/**
 * "sec-svc-flagship" intro band on a service page.
 * @param {string[]} paragraphs
 */
export default function ServiceOverview({ paragraphs = [] }) {
    return (
        <section className="container sec-svc-flagship">
            <div className="svc-overview">
                {paragraphs.map((text, i) => (
                    <p key={i}>{text}</p>
                ))}
            </div>
        </section>
    );
}
